import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Menu,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useFormik } from "formik";
import { IconButton } from "@mui/material";
import * as XLSX from "xlsx";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../AuthProvider";


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const StudentPromotionList = () => {
  const navigate = useNavigate();
  const { oId,board,pId,userId,role } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Original API data
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
const [sscClassSectionData, setSscClassSectionData] = useState([]);
const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState("Class-I");
const [sscSelectedSection, setSscSelectedSection] = useState("Section-A");

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
const [interSelectedSection, setInterSelectedSection] = useState("Section-A");
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");



  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };



    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState("");
    const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const UserId = userId || selectedUsers;
    console.log("Selected User:",UserId);
  
  
   
      const fetchUsers = async () => {
          try {
              const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
              if (!response.ok) {
                  throw new Error('Failed to fetch users');
              }
              const data = await response.json();
              setUsers(data);
              if (data.length > 0) {
                setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
            }
          } catch (error) {
              console.error('Error fetching users:', error);
          }
      };
  useEffect(() => {
    if (isPrincipal) {
      fetchUsers();
    }
  }, []); // ✅ Only runs on mount

// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setSscClassSectionData(data);
      const classes = data.map(item => item.classRegistration);
      setSscClassOptions(classes);

      let defaultClass = sscSelectedClass || (classes.includes("Class-I") ? "Class-I" : classes[0] || "");
      setSscSelectedClass(defaultClass);

      const defaultClassData = data.find(item => item.classRegistration === defaultClass);
      if (defaultClassData) {
        const sections = defaultClassData.sections.split(",");
        setSscSectionOptions(sections);
        setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
      } else {
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};


// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!UserId || !sscSelectedClass || !sscSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admission/adm/getAllFilterWithClassesAndSection/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
    if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      if (!selectedCourseType) {
        setSelectedCourseType(data[0] || "");
      }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!UserId || !selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admission/adm/getAllFilterWithClassesAndSectionOnlyStudents/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board, selectedCourseType, oId]);  // Removed selectedClass dependency here




// INTERMEDIATE: When class or course type changes, update sections
useEffect(() => {
  const updateIntermediateSections = async () => {
    if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
      await fetchSectionsData();
    }
  };
  updateIntermediateSections();
}, [interSelectedClass, selectedCourseType, board]);




// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
useEffect(() => {
  if (board === "SSC") {
    if (!sscSelectedClass || !sscSelectedSection) return;
    fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  } else if (board === "INTERMEDIATE") {
    if (!interSelectedClass || !interSelectedSection || !selectedCourseType) return;
    fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  }
}, [UserId,board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);




  useEffect(() => {
    if (!searchQuery) {
      setFilteredData(originalData); // Reset to original data if search query is empty
      return;
    }

    const result = originalData.filter((student) => {
      const searchTerm = searchQuery.toLowerCase();
      return (
        String(student.generatedAdmissionNumber).toLowerCase().includes(searchTerm) || // Add search by admission number
        String(student.surName).toLowerCase().includes(searchTerm) ||
        String(student.firstName).toLowerCase().includes(searchTerm) ||
        String(student.lastName).toLowerCase().includes(searchTerm) ||
        String(student.primaryContact).includes(searchTerm)
      );
    });

    setFilteredData(result);
  }, [searchQuery, originalData]);



 
  const handleOpen = (row) => {
    setFormData(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const romanClassMap = {
    NURSERY: "LKG",
    LKG: "UKG",
    UKG: "Class-I",
    "Class-I": "Class-II",
    "Class-II": "Class-III",
    "Class-III": "Class-IV",
    "Class-IV": "Class-V",
    "Class-V": "Class-VI",
    "Class-VI": "Class-VII",
    "Class-VII": "Class-VIII",
    "Class-VIII": "Class-IX",
    "Class-IX": "Class-X",
    "Inter-1st-Year": "Inter-2nd-Year",
  };
  
  // Automatically update 'toClass' when 'fromClass' changes
  useEffect(() => {
    setFormData((prev) => {
      const nextClass = romanClassMap[prev.romanNumberClass] || "";
      
      // Only update if 'toClass' is different to prevent unnecessary re-renders
      return prev.toClass !== nextClass
        ? { ...prev, toClass: nextClass }
        : prev;
    });
  }, [formData.romanNumberClass, setFormData]); 
  

  const handleSave = async () => {
    if (!formData.studentId) {
      toast.error("Admission number is missing.", { autoClose: 2000 });
      return;
    }

    // Create a FormData object and append the required fields
    const updatedFormData = new FormData();
    updatedFormData.append("surName", formData.surName || "");
    updatedFormData.append("firstName", formData.firstName || "");
    updatedFormData.append("lastName", formData.lastName || "");
    updatedFormData.append("primaryContact", formData.primaryContact || "");
    updatedFormData.append("sections", formData.sections || "");
    // updatedFormData.append("admissionFee", formData.admissionFee || "");
    updatedFormData.append("tutionFee", formData.tutionFee || "");

    try {
      const response = await fetch(
        `${baseUrl}/api/studentPromotion/promote/${formData.romanNumberClass}/${formData.studentId}/${oId}/${pId}`,
        {
          method: "PUT",
          body: updatedFormData, // Send FormData instead of JSON
        }
      );

      if (response.ok) {
        toast.success("Student Promoted successfully!", { autoClose: 2000 });
        
        if(board === "INTERMEDIATE") {
          fetchCourseClassSectionTableData();
        }else if(board === "SSC"){
          fetchClassSectionTableData();
        }
        handleClose();
      } else {
        toast.error("Failed to update student details.", { autoClose: 2000 });
      }
    } catch (error) {
      console.error("Error updating student details:", error);
      toast.error("An error occurred while updating student details.", {
        autoClose: 2000,
      });
    }
  };






  const exportToExcel = () => {
    const isIntermediate = board === "INTERMEDIATE";
    const dynamicKey = isIntermediate ? "Year" : "Class";

    const processedData = filteredData.map(
      ({
        generatedAdmissionNumber,
        admissionDate,
        course,
        romanNumberClass,
        sections,
        firstName,
        lastName,
        gender,
        fathersFirstName,
        fathersLastName,
        mothersFirstName,
        mothersLastName,
        primaryContact,
      }) => ({
        AdmissionNumber: generatedAdmissionNumber,
        AdmissionDate: admissionDate,
        ...(isIntermediate ? { Course: course } : {}),
      [dynamicKey]: romanNumberClass,
        Section: sections,
        StudentName: `${firstName} ${lastName}`,
        Gender: gender,
        FatherName: `${fathersFirstName} ${fathersLastName}`,
        MotherName: `${mothersFirstName} ${mothersLastName}`,
        Phone: primaryContact,
      })
    );

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      board === "INTERMEDIATE"
      ? `${interSelectedClass}-${interSelectedSection}_PromotedStudentsList`
      : `${sscSelectedClass}-${sscSelectedSection}_PromotedStudentsList`
      // `${selectedClass}-${selectedSection}_PromotedStudentsList`
    );

    // Add headers
    worksheet.columns = [
      { header: "Admission No", key: "AdmissionNumber", width: 15 },
      { header: "Admission Date", key: "AdmissionDate", width: 15 },
      ...(board === "INTERMEDIATE"
        ? [{ header: "Course", key: "Course", width: 15 }]
        : []),
      { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
      { header: "Section", key: "Section", width: 10 },
      { header: "Student Name", key: "StudentName", width: 25 },
      { header: "Gender", key: "Gender", width: 10 },
      { header: "Father Name", key: "FatherName", width: 20 },
      { header: "Mother Name", key: "MotherName", width: 20 },
      { header: "Phone", key: "Phone", width: 15 },
    ];

    // Add data to worksheet
    processedData.forEach((data) => {
      worksheet.addRow(data);
    });

    // Style headers
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" }, // Light Blue Header
      };
    });

    // Write and download file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = board === "INTERMEDIATE"
    ? `${interSelectedClass}-${interSelectedSection}_PromotedStudentsList.xlsx`
    : `${sscSelectedClass}-${sscSelectedSection}_PromotedStudentsList.xlsx`;
      link.click();
    });

    handleExportClose();
  };

  // Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
  
    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
  
    const title =
      board === "INTERMEDIATE"
        ? `${interSelectedClass}-${interSelectedSection} Promoted Students List`
        : `${sscSelectedClass}-${sscSelectedSection} Promoted Students List`;
    doc.text(title, 10, 8);
  
    // Generated On
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Generated On: ", 14, 16);
    doc.setFont("helvetica", "bold");
    doc.text(new Date().toLocaleDateString(), 40, 16);
  
    // Define headers dynamically
    const headers = board === "INTERMEDIATE"
      ? [
          "S.No",
          "Admission No",
          "Admission Date",
          "Course", // <-- Include course here
          "Year",
          "Section",
          "Student Name",
          "Gender",
          "Father Name",
          "Mother Name",
          "Phone",
        ]
      : [
          "S.No",
          "Admission No",
          "Admission Date",
          "Class",
          "Section",
          "Student Name",
          "Gender",
          "Father Name",
          "Mother Name",
          "Phone",
        ];
  
    // Define body data dynamically
    const bodyData = filteredData.map((row, index) => {
      const baseData = [
        index + 1,
        row.generatedAdmissionNumber,
        row.admissionDate,
      ];
  
      if (board === "INTERMEDIATE") {
        baseData.push(row.course); // Include course field
      }
  
      baseData.push(
        `${row.romanNumberClass}`,
        row.sections,
        `${row.firstName} ${row.lastName}`,
        row.gender,
        `${row.fathersFirstName} ${row.fathersLastName}`,
        `${row.mothersFirstName} ${row.mothersLastName}`,
        row.primaryContact
      );
  
      return baseData;
    });
  
    // Generate table
    doc.autoTable({
      startY: 20,
      head: [headers],
      body: bodyData,
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181],
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });
  
    // Save file
    const fileName =
      board === "INTERMEDIATE"
        ? `${interSelectedClass}-${interSelectedSection}_PromotedStudentsList.pdf`
        : `${sscSelectedClass}-${sscSelectedSection}_PromotedStudentsList.pdf`;
  
    doc.save(fileName);
    handleExportClose();
  };
  

  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredData, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    if(board === "INTERMEDIATE") {
      link.download = `${interSelectedClass}-${interSelectedSection}_PromotedStudentsList.json`;
    } else {
      link.download = `${sscSelectedClass}_${sscSelectedSection}_PromotedStudentsList.json`;
    }

    link.click();
    handleExportClose();
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          {/* <Typography
            variant="h5"
            sx={{ fontWeight: "bold", mb: 3, textAlign: "center" }}
          >
            Student List
          </Typography> */}
          <Box display="flex" alignItems="center" sx={{ marginBottom: 5 }}>
            {/* <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton> */}
            <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
              Promoted Student List
            </Typography>
          </Box>

          <Box display="flex" mb={3} flexWrap="wrap">
            <TextField
              label="Search by Name Or Mobile No"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ marginRight: 2 }}
            />

            {board === "SSC" && (
              <>
                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="class-select-label">Select Class</InputLabel>
                  <Select
                    labelId="class-select-label"
                    value={sscSelectedClass}
                    onChange={(e) => setSscSelectedClass(e.target.value)}
                    label="Select Class"
                    sx={{ height: 35 }}
                  >
                    {sscClassOptions.map((cls) => (
                      <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
            
                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="section-select-label">Select Section</InputLabel>
                  <Select
                    labelId="section-select-label"
                    value={sscSelectedSection}
                    onChange={(e) => setSscSelectedSection(e.target.value)}
                    label="Select Section"
                    sx={{ height: 35 }}
                    disabled={sscSectionOptions.length === 0}
                  >
                    {sscSectionOptions.map((section) => (
                      <MenuItem key={section} value={section}>{section}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}
            
            
            {board === "INTERMEDIATE" && (
              <>
                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
                  <Select
                    labelId="intermediate-class-select-label"
                    value={interSelectedClass}
                    onChange={(e) => setInterSelectedClass(e.target.value)}
                    label="Select Year"
                    sx={{ height: 35 }}
                  >
                    <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                    <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                  </Select>
                </FormControl>
            
                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="course-type-label">Select Course</InputLabel>
                  <Select
                    labelId="course-type-label"
                    value={selectedCourseType}
                    onChange={(e) => setSelectedCourseType(e.target.value)}
                    label="Select Course"
                    sx={{ height: 35 }}
                  >
                    {courseOptions.map((course, index) => (
                      <MenuItem key={index} value={course}>{course}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
            
                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
                  <Select
                    labelId="intermediate-section-select-label"
                    value={interSelectedSection}
                    onChange={(e) => setInterSelectedSection(e.target.value)}
                    label="Select Section"
                    sx={{ height: 35 }}
                  >
                    {interSectionOptions.map((section, index) => (
                      <MenuItem key={index} value={section}>{section}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}

 {isPrincipal && (
          <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
            <InputLabel>Select Admin</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select Admin"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId}-{user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

            

            <Box sx={{ flexGrow: 1 }} />
            <Grid
              item
              xs={3}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                variant="contained"
                onClick={handleExportClick}
                style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  },
                }}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    color: "#3f51b5",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f0fe",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#00796b" }}>
                    <SimCardDownloadIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Excel"
                    sx={{ fontWeight: "bold", color: "#00796b" }}
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    color: "#d32f2f",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#fdecea",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#d32f2f" }}>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="PDF"
                    sx={{ fontWeight: "bold", color: "#d32f2f" }}
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToJSON}
                  sx={{
                    color: "#388e3c",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f5e9",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#6a1b9a" }}>
                    <FilePresentIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="JSON"
                    sx={{ fontWeight: "bold", color: "#6a1b9a" }}
                  />
                </MenuItem>
              </Menu>
            </Grid>
  
          </Box>

          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Admission No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Admission Date
                  </TableCell>
                  {(board === "INTERMEDIATE" ) && (
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Course
                  </TableCell>
                  )}
                  {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" }}>Admission Number</TableCell> */}
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid #ddd",
                                        padding: "4px",
                                        backgroundColor: "#fff9c4",
                                        textAlign: "center",
                                        fontWeight: "Bold",
                                      }}
                                    >
                                      {board === "INTERMEDIATE" ? "Year" : "Class"}
                                    </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Section
                  </TableCell>

                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Father Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Mother Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Mobile No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Gender
                  </TableCell>

                  {/* <TableCell
                    sx={{
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Full Details
                  </TableCell> */}
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                    {/* <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          <CircularProgress size={20} />
        </TableCell> */}{" "}
                    <TableCell
                      colSpan={12}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={row.generatedAdmissionNumber}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.admissionNumber}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.admissionDate}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        Class-{row.romanNumberClass}
                      </TableCell> */}
                       {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.course}
                      </TableCell>
                      )}

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                        }}
                      >
                        {["NURSERY", "LKG", "UKG"].includes(
                          row.romanNumberClass?.toString().trim()
                        )
                          ? row.romanNumberClass
                          : `${row.romanNumberClass}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.sections}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >{`${row.firstName} ${row.lastName}`}</TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.fathersFirstName}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {row.mothersFirstName}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.primaryContact}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.gender}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        <Button
                          type="button"
                          // onClick={handleOpen}
                          onClick={() => handleOpen(row)} // Pass the row data to handleOpen
                          sx={{
                            backgroundColor: row.romanNumberClass === "Class-X" || row.romanNumberClass === "Inter-2nd-Year" ? "#ccc" : "#1976d2",
                            // backgroundColor: "#1976d2",
                            color: "white",
                            fontSize: "0.6rem", // Reduces the font size
                            // padding: "5px 10px",  // Reduces the padding
                            height: "25px", // Reduces the height
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          }}
                          disabled={row.romanNumberClass === "Class-X" || row.romanNumberClass === "Inter-2nd-Year"}
                        >
                          Promote Student
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>

          {/* Dialog for Editing Row Data */}
          <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle variant="h4">Promote Student</DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="dense"
                    name="firstName"
                    label="Name Of The Student"
                    value={`${formData.surName || ""} ${
                      formData.firstName || ""
                    } ${formData.lastName || ""}`}
                    disabled
                    InputProps={{
                      style: { backgroundColor: "#f0f0f0", color: "#6c757d" },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="dense"
                    name="fathersFirstName"
                    label="Father Name"
                    value={formData.fathersFirstName || ""}
                    disabled
                    InputProps={{
                      style: { backgroundColor: "#f0f0f0", color: "#6c757d" },
                    }}
                  />
                </Grid>
              </Grid>
          <Grid container spacing={2}>
              <Grid item xs={6}>
              <TextField
                fullWidth
                margin="dense"
                name="primaryContact"
                label="Primary Contact"
                value={formData.primaryContact || ""}
                // onChange={handleChange}
                disabled
                InputProps={{
                  style: { backgroundColor: "#f0f0f0", color: "#6c757d" }, // Light gray background and muted text color
                }}
              />
              </Grid>
      {(board === "INTERMEDIATE" ) && (
              <Grid item xs={6}>
              <TextField
                fullWidth
                margin="dense"
                name="course"
                label="Course"
                value={formData.course || ""}
                // onChange={handleChange}
                disabled
                InputProps={{
                  style: { backgroundColor: "#f0f0f0", color: "#6c757d" }, // Light gray background and muted text color
                }}
              />
              </Grid>
              
            )}
              </Grid>



              <Grid container spacing={2}>
                <Grid item xs={6}>
                  {/* From Class Field (Auto-filled from table) */}
                  <TextField
                    fullWidth
                    margin="dense"
                    name="romanNumberClass"
                    label={board === "INTERMEDIATE" ? "From Year" : "From Class"}
                    value={
                      formData.romanNumberClass
                        ? `${formData.romanNumberClass}`
                        : ""
                    }
                    disabled
                    InputProps={{
                      style: { backgroundColor: "#f0f0f0", color: "#6c757d" }, // Light gray background and muted text color
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  {/* To Class Field (Auto-updated based on From Class) */}
                  <TextField
                    fullWidth
                    margin="dense"
                    name="toClass"
                    label={board === "INTERMEDIATE" ? "To Year" : "To Class"}
                    value={formData.toClass ? `${formData.toClass}` : ""}
                    // InputProps={{ readOnly: true }} // Read-only to prevent manual changes
                    disabled
                    InputProps={{
                      style: { backgroundColor: "#f0f0f0", color: "#6c757d" }, // Light gray background and muted text color
                    }}
                  />
                </Grid>
              </Grid>

              {/* Section Select Field */}
              <TextField
                select
                fullWidth
                margin="dense"
                name="sections"
                label="Section"
                value={formData.sections || ""}
                onChange={handleChange}
              >
                <MenuItem value="Section-A">Section-A</MenuItem>
                <MenuItem value="Section-B">Section-B</MenuItem>
                <MenuItem value="Section-C">Section-C</MenuItem>
                <MenuItem value="Section-D">Section-D</MenuItem>
              </TextField>

              {/* <TextField
                fullWidth
                margin="dense"
                name="admissionFee"
                label="Admission Fee"
                value={formData.admissionFee || ""}
                onChange={handleChange}
              /> */}
              <TextField
                fullWidth
                margin="dense"
                name="tutionFee"
                label="School Fee"
                value={formData.tutionFee || ""}
                onChange={handleChange}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary" variant="outlined">
                Cancel
              </Button>
              <Button
                onClick={handleSave}
                color="success"
                variant="outlined"
                sx={{
                  backgroundColor: "#3C3972",
                  color: "white",
                  fontSize: "0.8rem", // Reduces the font size
                  // padding: "5px 10px",  // Reduces the padding
                  height: "35px", // Reduces the height
                  "&:hover": {
                    backgroundColor: "#3C3972",
                  },
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>

          <ToastContainer position="top-right" autoClose={2000} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default StudentPromotionList;
